module.exports = __webpack_public_path__ + "img/goals2.99212bf9.png";